export default __webpack_public_path__ + "static/media/give50logos.9974975d.svg";